<template>
  <ENewPersonalCounter
    v-if="showNew"
    :should-increment="shouldIncrement"
    data-test-id="personal-counter-new"
  />
  <EOldPersonalCounter
    v-else
    data-test-id="personal-counter"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import { NEW_PERSONAL_COUNTER } from 'common-js/constants/feature-flags';

import ENewPersonalCounter from './new';
import EOldPersonalCounter from './old';

export default {
  name: 'EPersonalCounter',
  components: {
    ENewPersonalCounter,
    EOldPersonalCounter,
  },
  props: {
    shouldIncrement: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('goodall', ['getExperiment']),
    showNew() {
      return this.getExperiment(NEW_PERSONAL_COUNTER.flag)?.includes(NEW_PERSONAL_COUNTER.enabled);
    },
  },
};
</script>
